import { jsx as _jsx } from "react/jsx-runtime";
import { TwoFaUpdateDetailsPopup } from './two-fa-update-details-popup';
import { useFeatureFlags } from '../../../../infra/feature-flags';
import { useSession } from '../../../../infra/session';
import { canSeeTwoFaOptInModal, getUpdateDetailsUrl } from './utils';
import { useTwoFaAnnouncementPopup } from './use-two-fa-announcement-popup';
var TWO_FA_OPT_IN_OPEN_INFO_LAST_SHOWN = '2fa_optInOpenInfoLastShown';
export var TwoFaOptInAvailableContainer = function () {
    var featureFlags = useFeatureFlags();
    var session = useSession().data;
    var _a = useTwoFaAnnouncementPopup({
        session: session,
        canUserSeeModal: canSeeTwoFaOptInModal(session, featureFlags),
        didUserTakeAction: session === null || session === void 0 ? void 0 : session.user.optIn2FA,
        modalSeenVariableName: TWO_FA_OPT_IN_OPEN_INFO_LAST_SHOWN,
    }), modal = _a.modal, handleClose = _a.handleClose;
    var updateButtonUrl = getUpdateDetailsUrl(session, true);
    if (!modal.isOn) {
        return null;
    }
    return _jsx(TwoFaUpdateDetailsPopup, { onClose: handleClose, updateButtonUrl: updateButtonUrl, optInEnabled: true });
};
